export const chartNonSeries = [
    {
        label: "Jan",
        value: 1600,
        color: "black",
        radius: 140,
    },
    {
        label: "Feb",
        value: 1450,
        color: "lightgreen",
        radius: 170,
    },
    {
        label: "Mar",
        value: 1700,
        color: "lightblue",
        radius: 130,
    },
    {
        label: "Apr",
        value: 1500,
        color: "blue",
        radius: 100,
    },
    {
        label: "May",
        value: 1350,
        color: "purple",
        radius: 80,
    },
    {
        label: "Jun",
        value: 1900,
        color: "red",
        radius: 240,
    },
    {
        label: "Jul",
        value: 2000,
        color: "green",
        radius: 200,
    },
    {
        label: "Aug",
        value: 1750,
        color: "pink",
        radius: 160,
    },
    {
        label: "Sep",
        value: 1300,
        color: "orange",
        radius: 80,
    },
    {
        label: "Oct",
        value: 1800,
        color: "yellow",
        radius: 140,
    },
    {
        label: "Nov",
        value: 1850,
        color: "gray",
        radius: 150,
    },
    {
        label: "Dec",
        value: 1650,
        color: "green",
        radius: 100,
    },
];

export const chartNestedSeriesWithoutExtraData = [
    {
        label: "Jan",
        count: 30,
        amount: 1600,
    },
    {
        label: "Feb",
        count: 25,
        amount: 1450,
    },
    {
        label: "Mar",
        count: 27,
        amount: 1700,
    },
    {
        label: "Apr",
        count: 30,
        amount: 1500,
    },
    {
        label: "May",
        count: 35,
        amount: 1350,
    },
    {
        label: "Jun",
        count: 28,
        amount: 1900,
    },
    {
        label: "Jul",
        count: 29,
        amount: 2000,
    },
    {
        label: "Aug",
        count: 20,
        amount: 1750,
    },
    {
        label: "Sep",
        count: 35,
        amount: 1300,
    },
    {
        label: "Oct",
        count: 32,
        amount: 1800,
    },
    {
        label: "Nov",
        count: 45,
        amount: 1850,
    },
    {
        label: "Dec",
        count: 40,
        amount: 1650,
    },
];

export const chartNestedSeriesWithExtraData = [
    {
        label: "Jan",
        count: {
            value: 30,
            color: "black",
        },
        amount: {
            value: 1600,
            color: "black",
        },
    },
    {
        label: "Feb",
        count: {
            value: 25,
            color: "lightgreen",
        },
        amount: {
            value: 1450,
            color: "lightgreen",
        },
    },
    {
        label: "Mar",
        count: {
            value: 27,
            color: "lightblue",
        },
        amount: {
            value: 1700,
            color: "lightblue",
        },
    },
    {
        label: "Apr",
        count: {
            value: 30,
            color: "blue",
        },
        amount: {
            value: 1500,
            color: "blue",
        },
    },
    {
        label: "May",
        count: {
            value: 35,
            color: "purple",
        },
        amount: {
            value: 1350,
            color: "purple",
        },
    },
    {
        label: "Jun",
        count: {
            value: 28,
            color: "red",
        },
        amount: {
            value: 1900,
            color: "red",
        },
    },
    {
        label: "Jul",
        count: {
            value: 29,
            color: "green",
        },
        amount: {
            value: 2000,
            color: "green",
        },
    },
    {
        label: "Aug",
        count: {
            value: 20,
            color: "pink",
        },
        amount: {
            value: 1750,
            color: "pink",
        },
    },
    {
        label: "Sep",
        count: {
            value: 35,
            color: "orange",
        },
        amount: {
            value: 1300,
            color: "orange",
        },
    },
    {
        label: "Oct",
        count: {
            value: 32,
            color: "yellow",
        },
        amount: {
            value: 1800,
            color: "yellow",
        },
    },
    {
        label: "Nov",
        count: {
            value: 45,
            color: "gray",
        },
        amount: {
            value: 1850,
            color: "gray",
        },
    },
    {
        label: "Dec",
        count: {
            value: 40,
            color: "green",
        },
        amount: {
            value: 1650,
            color: "green",
        },
    },
];

export const chartNonNestSeries = {
    count: [
        {
            label: "Jan",
            value: 30,
            color: "black",
        },
        {
            label: "Feb",
            value: 25,
            color: "lightgreen",
        },
        {
            label: "Mar",
            value: 27,
            color: "lightblue",
        },
        {
            label: "Apr",
            value: 30,
            color: "blue",
        },
        {
            label: "May",
            value: 35,
            color: "purple",
        },
        {
            label: "Jun",
            value: 28,
            color: "red",
        },
        {
            label: "Jul",
            value: 29,
            color: "green",
        },
        {
            label: "Aug",
            value: 20,
            color: "pink",
        },
        {
            label: "Sep",
            value: 35,
            color: "orange",
        },
        {
            label: "Oct",
            value: 32,
            color: "yellow",
        },
        {
            label: "Nov",
            value: 45,
            color: "gray",
        },
        {
            label: "Dec",
            value: 40,
            color: "green",
        },
    ],
    amount: [
        {
            label: "Jan",
            value: 1600,
            color: "black",
        },
        {
            label: "Feb",
            value: 1450,
            color: "lightgreen",
        },
        {
            label: "Mar",
            value: 1700,
            color: "lightblue",
        },
        {
            label: "Apr",
            value: 1500,
            color: "blue",
        },
        {
            label: "May",
            value: 1350,
            color: "purple",
        },
        {
            label: "Jun",
            value: 1900,
            color: "red",
        },
        {
            label: "Jul",
            value: 2000,
            color: "green",
        },
        {
            label: "Aug",
            value: 1750,
            color: "pink",
        },
        {
            label: "Sep",
            value: 1300,
            color: "orange",
        },
        {
            label: "Oct",
            value: 1800,
            color: "yellow",
        },
        {
            label: "Nov",
            value: 1850,
            color: "gray",
        },
        {
            label: "Dec",
            value: 1650,
            color: "green",
        },
    ],
};
